import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const SecuritySection = ({ security, onUpdatePassword, onToggle2FA }) => {
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e?.target?.name]: e?.target?.value });
  };

  const handlePasswordSubmit = () => {
    onUpdatePassword(passwordData);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setShowPasswordForm(false);
  };

  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-error/10 rounded-lg">
          <Icon name="Lock" size={24} color="var(--color-error)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Security Settings
          </h2>
          <p className="text-sm text-muted-foreground caption">
            Manage your account security
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="p-4 md:p-6 bg-muted/50 rounded-lg">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h3 className="text-lg font-heading font-semibold text-foreground">
                Password
              </h3>
              <p className="text-sm text-muted-foreground caption">
                Last changed: {security?.lastPasswordChange}
              </p>
            </div>
            {!showPasswordForm && (
              <Button
                variant="outline"
                size="default"
                iconName="Key"
                iconPosition="left"
                onClick={() => setShowPasswordForm(true)}
              >
                Change Password
              </Button>
            )}
          </div>

          {showPasswordForm && (
            <div className="space-y-4 pt-4 border-t border-border">
              <Input
                label="Current Password"
                type="password"
                name="currentPassword"
                value={passwordData?.currentPassword}
                onChange={handlePasswordChange}
                required
              />
              <Input
                label="New Password"
                type="password"
                name="newPassword"
                value={passwordData?.newPassword}
                onChange={handlePasswordChange}
                description="Must be at least 8 characters with uppercase, lowercase, and numbers"
                required
              />
              <Input
                label="Confirm New Password"
                type="password"
                name="confirmPassword"
                value={passwordData?.confirmPassword}
                onChange={handlePasswordChange}
                required
              />
              <div className="flex items-center justify-end gap-3">
                <Button
                  variant="outline"
                  size="default"
                  onClick={() => {
                    setShowPasswordForm(false);
                    setPasswordData({
                      currentPassword: '',
                      newPassword: '',
                      confirmPassword: ''
                    });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="default"
                  size="default"
                  iconName="Save"
                  iconPosition="left"
                  onClick={handlePasswordSubmit}
                >
                  Update Password
                </Button>
              </div>
            </div>
          )}
        </div>

        <div className="p-4 md:p-6 bg-muted/50 rounded-lg">
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-heading font-semibold text-foreground">
                  Two-Factor Authentication
                </h3>
                {security?.twoFactorEnabled && (
                  <div className="px-2 py-1 bg-success text-success-foreground rounded-full">
                    <span className="text-xs font-medium caption">Enabled</span>
                  </div>
                )}
              </div>
              <p className="text-sm text-muted-foreground caption">
                Add an extra layer of security to your account
              </p>
            </div>
            <Checkbox
              checked={security?.twoFactorEnabled}
              onChange={(e) => onToggle2FA(e?.target?.checked)}
            />
          </div>
        </div>

        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
            Recent Login Activity
          </h3>
          <div className="space-y-3">
            {security?.loginActivity?.map((activity, index) => (
              <div
                key={index}
                className="flex items-center justify-between p-4 bg-muted/50 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <div className="flex items-center justify-center w-10 h-10 bg-card rounded-lg">
                    <Icon name={activity?.device === 'Desktop' ? 'Monitor' : 'Smartphone'} size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{activity?.device}</p>
                    <p className="text-sm text-muted-foreground caption">
                      {activity?.location} • {activity?.date}
                    </p>
                  </div>
                </div>
                {index === 0 && (
                  <div className="px-3 py-1 bg-success/10 text-success rounded-full">
                    <span className="text-xs font-medium caption">Current</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;